import {Basic} from "./Basic";
import {Display} from "./Display";
import {Load} from "./Load";

export class Shop
{
    constructor()
    {
        this.containerProducts = document.body.querySelector('.w__shop--products');
        this.containerFilters = document.body.querySelector('.w__shop--filters');
        this.filters = [];
    }

    get_filters()
    {
        this.filters = [];
        const items = this.containerFilters.querySelectorAll('.w__input--checkbox:checked');
        items.forEach(el => {
            this.filters[this.filters.length] = {
                'type': el.dataset.filter,
                'value': el.dataset.value,
            }
        });

        const mySearch = document.body.querySelector('.w__shop--filters .w__input--text'),
              mySearchP = mySearch.closest('.w__shop--search-container');
        if(mySearch.value.trim())
        {
            mySearchP.classList.add('active');
            this.filters[this.filters.length] = {
                'type': 'search',
                'value': mySearch.value.trim()
            };
        }
        else
        {
            mySearchP.classList.remove('active');
        }

        sessionStorage.setItem('shop-filters', JSON.stringify(this.filters));
    }

    refresh_products()
    {
        this.get_filters();

        Load.post(
            Basic.base + 'shop',
            {
                f: 'shop',
                action: 'refresh-products',
                filters: this.filters
            }).then(r =>
        {
            this.containerProducts.innerHTML = r['html'].toString();
            this.containerProducts.scrollIntoView();
        }).catch(error =>
        {
            console.error(error);
        });
    }

    static reset_filters()
    {
        const myCheckboxes = document.body.querySelectorAll('.w__shop--filters .w__input--checkbox:checked'),
              mySearch = document.body.querySelector('.w__shop--filters .w__input--text');
        if(myCheckboxes.length > 0 || mySearch.value)
        {
            mySearch.value = '';
            mySearch.closest('.w__shop--search-container').classList.remove('active');

            myCheckboxes.forEach(el => {
                el.checked = false;
            });

            const myShop = new Shop();
            myShop.refresh_products();
        }
    }

    static reset_search(el)
    {
        const p = el.closest('.w__shop--search-container');
        if(p)
        {
            p.classList.remove('active');
            p.querySelector('.w__input--text').value = '';
            const myShop = new Shop();
            myShop.refresh_products();
        }
    }

    static restore_filters(filterPane)
    {
        const myFilters = JSON.parse(sessionStorage.getItem('shop-filters'));
        myFilters.forEach(f => {
            if(f.type === 'search')
            {
                filterPane.querySelector('.w__input--text').value = f.value;
            }
            else
            {
                const filter = filterPane.querySelector('.w__input--checkbox[data-filter="' + f.type + '"][data-value="' + f.value + '"]');
                filter.checked = true;
            }
        });
    }

    static toggle_filter(el)
    {
        if(el.classList.contains('w__button'))
        {
            const myCheckbox = document.body.querySelector(
                '.w__shop--filters .w__input--checkbox[data-filter="category"][data-value="' + el.dataset.value + '"]')
            if(myCheckbox)
            {
                myCheckbox.checked = true;
                Shop.toggle_filterPane();
            }
        }
        const myShop = new Shop();
        myShop.refresh_products();
    }

    static toggle_filterPane()
    {
        if(Display.device === 'smartphone')
        {
            const categorySection = document.body.querySelector('.w__filter--section.mod--category'),
                categoryFilter = categorySection.querySelector('.w__input--checkbox:checked');
            if(!categoryFilter)
            {
                categorySection.removeAttribute('open');
            }
            else
            {
                categorySection.setAttribute('open','');
            }
        }
    }
}